import { ChipProps } from '@mui/material';
import { TaskStatusEnum, TASK_STATUS_MAP } from 'shared/ui/formik-fields/task-status-picker-field';

export type TaskStatusMeta = {
  label: string;
  chipColor: ChipProps['color'];
  stripeColor: string;
};

const DEFAULT_STATUS_META: TaskStatusMeta = {
  label: 'Неизвестно',
  chipColor: 'default',
  stripeColor: 'grey.500',
};

const STATUS_META_MAP: Record<TaskStatusEnum, TaskStatusMeta> = {
  [TaskStatusEnum.NEW]: {
    label: TASK_STATUS_MAP[TaskStatusEnum.NEW],
    chipColor: 'info',
    stripeColor: 'info.main',
  },
  [TaskStatusEnum.IN_PROGRESS]: {
    label: TASK_STATUS_MAP[TaskStatusEnum.IN_PROGRESS],
    chipColor: 'warning',
    stripeColor: 'warning.main',
  },
  [TaskStatusEnum.COMPLETED]: {
    label: TASK_STATUS_MAP[TaskStatusEnum.COMPLETED],
    chipColor: 'success',
    stripeColor: 'success.main',
  },
  [TaskStatusEnum.CLOSED]: {
    label: TASK_STATUS_MAP[TaskStatusEnum.CLOSED],
    chipColor: 'default',
    stripeColor: 'grey.500',
  },
};

export const getTaskStatusMeta = (status?: number | null): TaskStatusMeta => {
  if (!status) {
    return DEFAULT_STATUS_META;
  }
  return STATUS_META_MAP[status as TaskStatusEnum] ?? DEFAULT_STATUS_META;
};
